<div class="dashboard-container" [ngClass]="{'full-view': isLogin, 'menu-view': !isLogin}">
  <div class="header" *ngIf="isLogin">
    <img src="assets/images/logo-upperleft.png" class="logo-image" alt="Logo">
    <div class="logo-title">
      {{'app.service_portal' | translate}}
    </div>
  </div>
  <div class="dashboard-content">
	    <span class="ui-g-8">
			<p class="para-one">{{'home.message.para_one' | translate}}</p>
			<p class="para-two">{{'home.message.para_two' | translate}}</p>
			<button pButton label="{{'home.message.start_btn' | translate}}" class="submit-button start-btn"
              id="dashboard-logo" (click)="showLoginForm()" *ngIf="isLogin"></button>
		</span>
  </div>
  <div class="related-links-section" *ngIf="isLogin">
    <div class="dashboard-links" (click)="openImprint()">Impressum</div>
    <div class="dashboard-links" *ngIf="showPrivacyPolicyLink" (click)="openPrivacyPolicy()">Datenschutz</div>
  </div>
</div>
